export default "__VITE_ASSET__a$nI0SA$__"